import React from 'react'

import { InstagramLike, InstagramComment, Giveaway } from '@bufferapp/ui/Icon'

import { Wrapper, Value, Placeholder } from './Counter.styles'

function getIcon(type: string): React.ElementType {
  switch (type) {
    case 'total-comments':
      return InstagramComment
    case 'answered-comments':
      return InstagramComment
    case 'unanswered-comments':
      return InstagramComment
    case 'likes':
      return InstagramLike
    case 'giveaway':
      return Giveaway
    default:
      return InstagramComment
  }
}

type CounterProps = {
  type?: string
  value?: number | string
  colors?: {
    icon?: string
    value?: string
  }
  placeholder?: boolean
  size?: string
}

const Counter = ({
  type = 'total-comments',
  value = 0,
  colors = {},
  placeholder = false,
  size = 'medium',
}: CounterProps): JSX.Element => {
  const { icon: iconColor, value: valueColor } = colors

  const Icon = getIcon(type)
  const testId = `counter-icon-${type}`

  return (
    // Temporary disable, this should be fixed in the future
    // eslint-disable-next-line jsx-a11y/aria-role
    <Wrapper color={iconColor} role="counter">
      <Icon data-testid={testId} size={size} />
      {placeholder ? (
        <Placeholder />
      ) : (
        <Value data-testid="counter-value" color={valueColor}>
          {value}
        </Value>
      )}
    </Wrapper>
  )
}

export default Counter
